import { useNavigate } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { StepShell, StepBody } from "./_StepShell";
import { StepHero } from "./_StepHero";

/**
 * Shown once on first sign-in (gate redirects here when
 * `user.firstName` is null). Now lives inside the OnboardingShell
 * so the rail is visible from the very first screen — the entire
 * onboarding feels like one continuous surface.
 *
 * No StepFooter — Welcome owns its own "Get started" CTA inline.
 */
export function WelcomeStep() {
  const navigate = useNavigate();
  return (
    <StepShell variant="form">
      <StepHero
        title="Welcome to Booqly"
        subtitle="Let's get your workspace set up. Should take about 5 minutes — you can always come back and tweak things later."
      />

      <StepBody>
        <div>
          <p className="text-[13px] font-medium text-foreground mb-3">
            What we'll cover
          </p>
          <ul className="space-y-2.5">
            {COVER_ITEMS.map((item) => (
              <li
                key={item}
                className="flex items-start gap-2.5 text-[14px] text-foreground"
              >
                <span className="shrink-0 mt-0.5 h-4 w-4 rounded-full bg-primary-light text-primary inline-flex items-center justify-center">
                  <Check className="h-2.5 w-2.5" />
                </span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div className="pt-2">
          <Button
            size="lg"
            onClick={() => navigate("/onboarding/personal")}
          >
            Get started
            <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </div>
      </StepBody>
    </StepShell>
  );
}

const COVER_ITEMS = [
  "Your name and photo",
  "Your workspace name and brand",
  "Invite teammates (optional — solo is fine)",
  "Pick a starter pack of services",
  "Choose a plan (free trial available)",
];
